export const SET_CURRENT_PAIR = 'SET_CURRENT_PAIR';
export const SET_LIST_PAIR = 'SET_LIST_PAIR';
export const SET_LIST_TOKEN = 'SET_LIST_TOKEN';
export const SET_SELECTED_SIZE = 'SET_SELECTED_SIZE';
export const SET_PAIR_LEVERAGE = 'SET_PAIR_LEVERAGE';
export const SET_TRADING_MODE = 'SET_TRADING_MODE';
export const SET_FAVORITE_PAIR = 'SET_FAVORITE_PAIR';
export const SET_PAIR_USER_DATA = 'SET_PAIR_USER_DATA';
export const SET_ORDER_FORM_PAIR_DATA = 'SET_ORDER_FORM_PAIR_DATA';